import styles from './NestedList.scss';
import { SafeHTML } from 'edrolo/domains/app';
/* eslint-disable react/prop-types */ // TODO: add props

const ListNode = ({ listStyle, items }) => {
  const Component = listStyle == 'ordered' ? 'ol' : 'ul';
  return (
    <Component className={styles.numberSubheading}>
      {items?.map((item, index) => (
        <li key={index}>
          <SafeHTML>{item.content}</SafeHTML>
          <ListNode key={index} listStyle={listStyle} items={item.items} />
        </li>
      ))}
    </Component>
  );
};

export const NestedList = ({ blockData }) => {
  const { style, items } = blockData;

  return (
    <div className={styles.numberSubheading}>
      <ListNode listStyle={style} items={items} />
    </div>
  );
};

export default NestedList;
